export default __webpack_public_path__ + "static/media/11.5ed7339f.jpg";